import { SCIM_PROVISIONING_EXT_ID, SOFIA_SUPPORT_MANAGERS_EMAILS } from './consts';

export function isVisiblePlatformUser(user) {
  if (!user) {
    return false;
  }
  if (user.extId === SCIM_PROVISIONING_EXT_ID) {
    return false;
  }
  if (SOFIA_SUPPORT_MANAGERS_EMAILS.includes(user.email)) {
    return false;
  }
  return true;
}

export function filterVisiblePlatformUsers(users) {
  return (users || []).filter(isVisiblePlatformUser);
}
